export const DISPERSEABI = {
    iotexTestnet: "0x3744c2e13e51A9305D2E9381f5E5D0BBd1a733a4",
    binanceTestnet: "0x95e212393e76fA88A7b7D9246c5197d0AEaba407",
    rinkebyTestnet: "0xdbcb48eFD02f2a337CA02d05CBB59c3BDe814EB3",
    hpbMainnet: "0x4FF748A9BbC1a69ABB28084A222E53265f535B8a",
    maticMainnet: "0x741fe89074C71a3734DEc225884ead4f38f24871",
    maticMumbai: "0x4cb70De91e6Bb85fB132880D5Af3418477a90083",
    fantomMainnet: "0x156F4F736F72c7965E43Fc129992AdC61809c6e1",
    fantomTestnet: "0xf04023D1bE23A89912abB37B915CbA678163A35A",
    celoMainnet: "0xe9e4a580EbF68A72daEF415dD4972792a539b6AE",
    celoTestnet: "0xe617D20245c9ffBDae17ecA5FBFe142fB22C6407",
    cubeTestnet: "0x9aF7eDbfDf3d7B3e2c55B2cF3B017Bc91CE7fB03",
    oneMainnet: "0xe54b15DBD84d3f643226CE571d890FDa12283D5F",
};